<script setup>
import { BriefcaseIcon, UserIcon } from '@heroicons/vue/outline'
import BaseCard from '../../base/BaseCard.vue'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { switchToNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { storeToRefs } from 'pinia'
import { useInvestmentProcessNavigation } from '../../../utilities/account/useInvestmentProcessNavigation'

const { pageKey } = storeToRefs(useInvestmentProcessNavigation())
</script>

<template>
    <BaseCard class="overflow-hidden">
        <div class="flex items-center space-x-3 border-b border-solid border-gray-300 px-4 py-3">
            <div class="flex items-center justify-center rounded-full border-2 border-gray-300 bg-white p-1.5">
                <BriefcaseIcon class="border-gray-150 w-5" />
            </div>
            <h3 class="text-base font-semibold leading-6 text-gray-700">
                {{ useLegalAccountDataState().legalProfile.company_name }}
            </h3>
        </div>
        <div class="">
            <p class="flex justify-between border-b border-gray-200 px-4 py-2 text-sm text-gray-600 odd:bg-gray-50">
                <span class="font-semibold">{{ $t('investment_process.registration_number') }}</span>
                <span class="text-right">{{ useLegalAccountDataState().legalProfile.registration_number }}</span>
            </p>
            <p class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.address') }}</span>
                <span class="text-right">{{ useLegalAccountDataState().legalProfile.address }}</span>
            </p>
        </div>
        <div v-if="pageKey !== 'payment'" class="flex justify-center border-t border-gray-300 p-3">
            <BaseButtonMuted class="w-full font-semibold" :icon="UserIcon" @click="switchToNaturalProfile"
                >{{ $t('investment_process.invest_as_natural_profile') }}
            </BaseButtonMuted>
        </div>
    </BaseCard>
</template>

<style scoped></style>
